import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const RocketIcon = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9997 2.57047C21.9597 2.23047 21.6897 1.96047 21.3497 1.92047C17.3797 1.42047 13.2997 2.83047 10.4197 5.71047L10.1897 5.94047L6.47969 5.92047C6.25969 5.90047 6.08969 6.00047 5.94969 6.14047L1.45969 10.6405C1.16969 10.9305 1.16969 11.4105 1.45969 11.7005L3.47969 13.7205L3.78969 14.0305L2.17969 15.6405C2.03969 15.7805 1.95969 15.9705 1.95969 16.1705C1.95969 16.3705 2.03969 16.5605 2.17969 16.7005L7.21969 21.7405C7.36969 21.8905 7.55969 21.9605 7.74969 21.9605C7.93969 21.9605 8.12969 21.8905 8.27969 21.7405L9.88969 20.1305L10.1997 20.4405L12.2197 22.4605C12.3697 22.6105 12.5597 22.6805 12.7497 22.6805C12.9397 22.6805 13.1297 22.6105 13.2797 22.4605L17.7697 17.9705C17.9097 17.8305 17.9897 17.6405 17.9897 17.4405L17.9697 13.7005L18.1897 13.4805C21.0697 10.6005 22.4897 6.51047 21.9797 2.55047L21.9997 2.57047ZM7.75969 20.1505L3.77969 16.1705L4.85969 15.0905L8.83969 19.0705L7.75969 20.1505ZM20.5797 3.35047C20.8197 6.67047 19.5597 10.0305 17.1497 12.4405L10.7397 18.8505L8.34969 16.4605L13.4797 11.3305L12.4197 10.2705L7.28969 15.4005L5.06969 13.1805L11.0297 7.22047L11.4797 6.77047C13.8897 4.36047 17.2497 3.10047 20.5697 3.34047L20.5797 3.35047ZM6.78969 7.43047H8.69969L4.00969 12.1305L3.04969 11.1705L6.78969 7.43047ZM16.5097 17.1505L12.7697 20.8905L11.7897 19.9105L16.4897 15.2105V17.1505H16.5097Z"
      fill={color}
    />
    <path
      d="M17.6601 9.0898C18.4401 8.3098 18.4401 7.0398 17.6601 6.2598C16.8801 5.4798 15.6101 5.4798 14.8301 6.2598C14.0501 7.0398 14.0501 8.3098 14.8301 9.0898C15.6101 9.8698 16.8801 9.8698 17.6601 9.0898Z"
      fill={color}
    />
  </svg>
);

export default RocketIcon;
